export * from './auth.component';
export * from './auth-block/auth-block.component';
export * from './login/login.component';
export * from './logout/logout.component';
export * from './register/register.component';
export * from './request-password/request-password.component';
export * from './reset-password/reset-password.component';



// WEBPACK FOOTER //
// ./src/framework/auth/components/index.ts